import React from "react";
import { DialogContent, Box, Divider } from "@material-ui/core";

import FixedPositionDialog from "../../../elements/FixedPositionDialog";
import DialogTitleWithCloseIcon from "../../../elements/DialogTitleWithCloseIcon";
import I18nText from "../../../elements/I18nText";
import FormattedDate from "../../../elements/FormattedDate";
import { nl2br } from "../../../utils/stringUtils";

const CommentListDialog = ({ comments, onClose }) => (
  <FixedPositionDialog open={true} scroll="body" fullWidth maxWidth="sm">
    <DialogTitleWithCloseIcon onClose={onClose}>
      <I18nText>devices.status.sections.comment</I18nText>
    </DialogTitleWithCloseIcon>
    <DialogContent>
      {comments.map((comment, index) => (
        <Box
          key={comment.id}
          marginBottom={index < comments.length - 1 ? 2 : 0}
        >
          <Box
            display="flex"
            justifyContent="space-between"
            fontSize={12}
            color="text.secondary"
            marginBottom={0.5}
          >
            <span>{comment.author || "system"}</span>
            <FormattedDate>{comment.date}</FormattedDate>
          </Box>
          <Box>{nl2br(comment.comment)}</Box>
          {index < comments.length - 1 && (
            <Box marginTop={2}>
              <Divider />
            </Box>
          )}
        </Box>
      ))}
    </DialogContent>
  </FixedPositionDialog>
);

export default CommentListDialog;
